import { useRef as s, useEffect as o } from "react";
const c = (e) => {
  const r = s(null);
  return o(() => {
    const n = (f) => {
      f.type === e && f.preventDefault();
    }, t = r.current;
    return t && t.addEventListener(e, n), () => {
      t && t.removeEventListener(e, n);
    };
  }, [e]), r;
};
export {
  c as usePreventEvent
};
